import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import api from "../../../api";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const BannerSection = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const options = {
    loop: true,
    margin: 0,
    nav: false,
    autoplay: true,
    autoplayTimeout: 10000,
    autoplayHoverPause: true,
    items: 1,
    dots: true,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/sliders");
        setSlides(response.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const bannerSlides =
    slides.length > 0
      ? slides
      : [
        {
          id: 1,
          heading: "Elevate Your Space with Elly Decor",
          subheading:
            "Discover exquisite home furnishings and decor at Elly Decor. From premium curtain fabrics to elegant sofa upholstery, find everything you need to create your dream home. Visit our store in Noida, Sector 150.",
          photo: "/dummy-banner.jpg",
          url: "#",
          link_text: "Explore Products",
          button_text: "Visit Store →",
        },
      ];

  return (
    <section className="banner-section-one full-banner">
      <OwlCarousel
        className="banner-carousel default-dots owl-theme"
        {...options}
      >
        {bannerSlides.map((slide) => (
          <div className="slide-item" key={slide.id}>
            <div
              className="bg-image"
              style={{
                backgroundImage: `url(${slide.photo || "/dummy-banner.jpg"})`,
              }}
            >
              <div className="banner-overlay"></div>
            </div>

            <div className="banner-container">
              <div className="content-box">
                {/* Heading */}
                <h2 className="bannerTitle text-center text-lg-start">
                  Elevate Your Space with <br />
                  <span class="underline-text">
                    Elly Decor
                    <svg viewBox="0 0 400 60" preserveAspectRatio="none">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 60" preserveAspectRatio="none" width="400" height="60">
                        <path d="M 10 30 
                                 L 390 30 
                                 L 10.2 36"
                          stroke="black"
                          stroke-width="2"
                          fill="none" />
                      </svg>


                    </svg>
                  </span>
                </h2>
                {/* Subheading */}
                <p className="bannerDesc">
                  {slide.subheading ||
                    "Discover exquisite home furnishings and decor at Elly Decor. From premium curtain fabrics to elegant sofa upholstery, find everything you need to create your dream home. Visit our store in Noida, Sector 150, or explore our collections online."}
                </p>

                {/* Buttons */}
                {/* <div className="bannerBtn">
                    <Link to={slide.url || "#"} className="theme-btn btn-style-three">
                      <span className="btn-title">
                        {slide.link_text || "Explore Products"}
                      </span>
                    </Link>

                    <button className="theme-btn btn-style-main">
                      {slide.button_text || "Visit Store →"}
                    </button>
                  </div> */}
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </section>
  );
};

export default BannerSection;
